module.exports = __webpack_public_path__ + "img/00.4199ab6a.png";